import type { PlansTabFormValues } from 'src/pages/Settings/memberships/components/plans-tab/types';

/**
 * Membership configuration must include at least one offered product (enabled plan).
 */
export function hasAtLeastOneEnabledProduct(formValues: PlansTabFormValues): boolean {
  const { plans } = formValues;
  return Array.isArray(plans) && plans.some((plan) => plan.enabled);
}
